import { DataSource, Layout, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFuelDetailHistoryList extends Layout {
    searchpanelFuelDetailHist: SearchPanel;
    sourceFuelDetailHistList: DataSource;
    tableFuelDetailHist: Table;
    textboxBatchno: Textbox;
    textboxFuelBillCode: Textbox;
    textboxFuelCardId: Textbox;
    textboxFuelCardpayeeId: Textbox;
    textboxMasterAccountNo: Textbox;
    textboxPostedPayeeId: Textbox;
    textboxSubAccountNo: Textbox;
    textboxTractorId: Textbox;
    textboxTransDateTime: Textbox;
    textboxTransNo: Textbox;
    textboxTransType: Textbox;
    textboxTransactionStatus: Textbox;
}
